const { formatTextAsRequired } = require("coremh/components/formatText");
const { handleQuotaUpdate } = require("./product/base");
const { productQuantityError, windowReload, closePersonalizationModal, setTriggerErrorMessage, disableButtons, getModalQuantity, calculatePersonalizationPrice } = require("./components/customBoxesHelpers");
const cartCustomBoxes = require("./components/cartCustomBoxes");

const $body = $("body");
let $boxBar;
let modalQuantity;

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    var pid;

    if ($("#quickViewModal").hasClass("show") && !$(".product-set").length) {
        pid = $($el).closest(".modal-content").find(".product-quickview").data("pid");
    } else if ($(".product-set-detail").length || $(".product-set").length) {
        pid = $($el).closest(".product-detail").find(".product-id").text();
    } else if ($(".custom-box-bar").length) {
        pid = $(".custom-box-bar").data("box-product-id");
    } else {
        pid = $(".product-detail:not('.bundle-item')").data("pid");
    }

    return pid;
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $(".bundle-item").each(function () {
        childProducts.push({
            pid: $(this).find(".product-id").text(),
            quantity: parseInt($(this).find("label.quantity").data("quantity"), 10),
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieves url to use when adding a product to the cart
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $(".add-to-cart-url").val();
}

/**
 * Retrieve context
 * ual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    var quantitySelected;
    if ($el && $(".set-items").length) {
        quantitySelected = $($el).closest(".product-detail").find(".quantity-select");
    } else if ($el && $(".product-bundle").length) {
        quantitySelected = $($el).closest("#personalization-form").find(".quantity-select");
    } else if ($el && $(".c-personalization-modal.show").length) {
        quantitySelected = $(".c-personalization-modal.show").find(".quantity-select");
    } else {
        quantitySelected = $(".quantity-select");
    }
    return quantitySelected;
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
function getQuantitySelected($el) {
    return getQuantitySelector($el).val();
}

/**
 * Retrieves the values associated with the personalization option type
 * @param {Boolean} - personalization isVCType or not
 * @return {Object|String} - values found in the form inputs
 */
function getPayload({ isVCType }) {
    if (isVCType) {
        return {
            city: $("#personalization-form-city").val().toUpperCase(),
            distance: $("#personalization-form-distance").val()
        };
    }

    return {
        message: $("#personalization-form-message").val()
    };
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    var $minicartQtyResource = $(".minicart-quantity").attr("data-resource");
    var $minicartQty = data.numItems < 100 ? data.numItems : $minicartQtyResource;
    var hasShippingNetPrice = data.totals.shippingTotalNetPrice && data.totals.shippingTotalNetPrice !== "-";
    var shippingCost = hasShippingNetPrice
        ? data.totals.shippingTotalNetPrice
        : data.totals.totalShippingCost;

    if (hasShippingNetPrice && data.totals.totalshippingCostWithDiscountValue === 0) {
        shippingCost = $(".shipping-cost").data("free-msg");
    }

    $(".cart-items-number").empty().append(data.resources.numberOfItems);
    $(".shipping-cost").empty().append(shippingCost);
    $(".tax-total").empty().append(data.totals.totalTax);
    $(".grand-total").empty().append(data.totals.grandTotal);
    $(".sub-total").empty().append(data.totals.totalNetPrice && data.totals.totalNetPrice !== "-" ? data.totals.totalNetPrice : data.totals.subTotal);
    $(".minicart-quantity").empty().append($minicartQty);
    $(".minicart-title span").empty().append(`(${data.resources.numberOfItems})`);
    $(".minicart-link").attr({
        "data-minicart-items": $minicartQty
    });
    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $(".order-discount").removeClass("hide-order-discount");
        $(".order-discount-total").empty()
            .append("- " + data.totals.orderLevelDiscountTotal.formatted);
    } else {
        $(".order-discount").addClass("hide-order-discount");
    }

    if (data.totals.shippingLevelDiscountTotal.value > 0) {
        $(".shipping-discount").removeClass("hide-shipping-discount");
        $(".shipping-discount-total").empty().append("- " +
            data.totals.shippingLevelDiscountTotal.formatted);
    } else {
        $(".shipping-discount").addClass("hide-shipping-discount");
    }

    data.items.forEach(function (item) {
        var lineItemPrice = item.priceTotal && item.priceTotal.netPrice ? item.priceTotal.netPrice + " HT" : item.priceTotal.price;

        if (data.totals.orderLevelDiscountTotal.value > 0) {
            $(".coupons-and-promos").empty().append(data.totals.discountsHtml);
        }
        if (item.renderedPromotions) {
            $(".item-" + item.UUID).empty().append(item.renderedPromotions);
        } else {
            $(".item-" + item.UUID).empty();
        }
        $(".uuid-" + item.UUID + " .unit-price").empty().append(item.renderedPrice);
        $(".line-item-price-" + item.UUID + " .price .price").empty().append(lineItemPrice);
        $(".item-total-" + item.UUID).empty().append(item.priceTotal.renderedPrice);
    });
}

/**
 * @description clears field error
 * @param {string} field
 */
function clearFieldError(field) {
    $(field).closest(".form-group")
        .removeClass("is-invalid")
        .find(".invalid-feedback")
        .empty();
}

/**
 * @description clears form errors
 * @param {JQuery} form
 */
function clearFormErrors(form) {
    form.find(".form-group :input")
        .each(function () {
            $(this).closest(".form-group")
                .removeClass("is-invalid")
                .find(".invalid-feedback")
                .empty();
        });
}

/**
 * @description check if distance field is 0 or empty
 * @param {Object} field
 * @returns {Boolean} true if distance is 0 or empty, false otherwise.
 */
function isDistanceNull(field) {
    return field.hasClass("personalization-distance-input") && (field.val() === "0" || field.val() === "");
}

/**
 * @description returns specific error for distance field
 * @param {Object} field
 * @returns {String} error message for distance
 */
function getDistanceError(field) {
    return field.data("error-message-secondary");
}

/**
 * @description shows field error
 * @param {JQuery} field
 */
function showFieldError(field) {
    const $field = $(field);
    const fieldErrorMsg = isDistanceNull($field) ? getDistanceError($field) : $field.data("error-message");
    $field.closest(".form-group")
        .addClass("is-invalid")
        .find(".invalid-feedback")
        .empty()
        .html(fieldErrorMsg);
}

/**
 * @description validates form field
 * @param {JQuery} field
 */
function validateFormField(field) {
    if (!field.value.length || !field.validity.valid || isDistanceNull($(field))) {
        showFieldError(field);
    } else {
        clearFieldError(field);
    }
}

/**
 * @description validates textarea field
 * @param {JQuery} field
 */
function validateTextAreaField(field) {
    if (!field.value.length || !checkTextAreaPattern($(field))) {
        showFieldError(field);
    } else {
        clearFieldError(field);
    }
}

/**
 * @description validates form fields
 * @param {jQuery} form
 */
function validateFormFields(form) {
    const $formInputs = form.find(".form-group :input");
    $formInputs.each(function () {
        if ($(this).is("textarea")) {
            validateTextAreaField(this);
        } else {
            validateFormField(this);
        }
    });
}

/**
 * returns profanity error message
 * @param {Object} errorObject - object with error message
 */
function profanityError(errorObject) {
    $("textarea, #personalization-form-city").closest(".form-group")
        .addClass("is-invalid")
        .find(".invalid-feedback")
        .empty()
        .html(errorObject.messageError);
}

/**
 * handles profanity error message
 * @param {Object} xhr
 */
function errorHandler(xhr) {
    const $limitationModal = $("#limitationModal");
    if ($limitationModal.length && xhr.responseJSON.errorMessage === "totalProductQtyEBExceeded") {
        $limitationModal.modal("show");
    }
    const objectHelpers = require("coremh/components/objectHelpers.js");
    const errorObject = objectHelpers.parseJSON(xhr.responseText);
    profanityError(errorObject);
    $.spinner().stop();
}

/**
 * @description checks form errors
 * @param {jQuery} form
 */
function checkErrors(form) {
    const formInputs = form.find(".form-group :input").toArray();
    const $textAreaField = form.find(".form-group textarea");
    if ($textAreaField.length && !checkTextAreaPattern($textAreaField)) {
        return true;
    }
    return formInputs.some(function (field) {
        return !field.value.length || !field.validity.valid || isDistanceNull($(field));
    });
}

/**
 * @description checks text area errors
 * @param {JQuery} textAreaField
 */
function checkTextAreaPattern(textAreaField) {
    const pattern = new RegExp(textAreaField.attr("pattern"));
    return pattern.test(textAreaField.val().toUpperCase());
}

/**
 * @description initialize select2 after modal close
 */
function closePersonalization() {
    const $productBundle = $(".product-bundle");
    if ($productBundle.length) {
        $productBundle.find(".quantity-select")
            .select2({
                minimumResultsForSearch: -1
            });
    } else {
        const $quantity = $(".product-detail-content .quantity-select");
        $quantity.select2({
            minimumResultsForSearch: -1
        });
    }
    $(".modal-backdrop").hide();
}

/**
* Handles the closing of the personalization UI when on a product detail page.
*/
function hiddenPersonalizationHandler() {
    if ($(".product-detail").length && window.isApplePayExpressEnabled && window.isExpressPaymentsEnabled) {
        $("body").trigger("personalization:closed");
    }
}

/**
 * @description open cart modal
 */
function openCartModal() {
    const $minicart = $(".minicart");
    const $header = $(".page-header");
    const $minicartPopover = $header.find(".minicart-popover");

    $minicart.find(".minicart-total").click();

    setTimeout(function() {
        $minicartPopover.find(".minicart-close-button").click();
    }, 5000);
}

/**
 * @description removes gift wrapping
 * @param {Object} e - event object
 */
function removeGiftwrapping(e) {
    e.preventDefault();
    var $currentBtn = $(this);
    var actionURL = $currentBtn.data("action-url");

    if (!actionURL) {
        return;
    }

    var form = {
        pliUUID: $currentBtn.data("pli-uuid"),
        optionId: $currentBtn.data("option-id"),
        csrf_token: $("[name=csrf_token]").val(),
        actionName: $currentBtn.data("giftwrapping-cbt-action-name")
    };

    $.ajax({
        url: actionURL,
        method: "POST",
        data: form,
        success: function (data) {
            if (!data.success) {
                $("#giftWrapModal").modal("hide");
                return;
            }
            $(`[data-giftwrapping-edit-btn-${data.pliUUID}]`).addClass("d-none");
            var $edit = $(`[data-giftwrapping-edit-${data.pliUUID}]`);
            $edit.addClass("d-none");
            data.cartModel && updateCartTotals(data.cartModel);
            $(`[data-giftwrapping-add-btn-${data.pliUUID}]`).removeClass("d-none");
            $("#giftWrapModal").modal("hide");
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * @description updates giftwrapping
 * @param {Object} e - event object
 */
function updateGiftwrapping(e) {
    e.preventDefault();
    $("body").trigger("product:beforeAddToCart", this);
    var $currentBtn = $(this);
    var actionURL = $currentBtn.data("action-url");

    if (!actionURL) {
        return;
    }
    var form = {
        pliUUID: $currentBtn.data("pli-uuid"),
        optionId: $currentBtn.data("option-id"),
        selectedValueId: $("[data-giftwrapping-option]").val(),
        csrf_token:  $("[name=csrf_token]").val(),
        actionName: $currentBtn.data("giftwrapping-cbt-action-name")
    };

    $($currentBtn).trigger("updateAddToCartFormData", form);

    $.ajax({
        url: actionURL,
        method: "POST",
        data: form,
        success: function (data) {
            if (!data.success) {
                $("#giftWrapModal").modal("hide");
                return;
            }
            $("body").trigger("product:afterAddToCart", data);
            $(`[data-giftwrapping-add-btn-${data.pliUUID}]`).addClass("d-none");
            var $edit = $(`[data-giftwrapping-edit-${data.pliUUID}]`);
            $edit.find(".giftwrapper-message").text(data.name);
            $edit.find(".giftwrapper-price").text(data.price);
            $edit.removeClass("d-none");
            data.cartModel && updateCartTotals(data.cartModel);
            $(`[data-giftwrapping-edit-btn-${data.pliUUID}]`).removeClass("d-none");
            $("#giftWrapModal").modal("hide");
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        },
    });
}

/**
 * @description Convert value for pesronalization message to uppercase
 */
function personalizationToUpperCase() {
    const $pesonalizationCity = $("#personalization-form-city");

    if ($pesonalizationCity.length > 0) {
        $pesonalizationCity.val($pesonalizationCity.val().toUpperCase());
    }
}

/**
* Collects product IDs and their selected quantities from the custom box bar UI component,
* formats them as an array of objects, and returns the result as a JSON string.
* If no products are found, returns an empty array.
*
* @returns {string|Array} - A JSON string representing an array of boxed product objects,
*                           each with `pid` and `quantity` properties, or an empty array if none found.
*/
function boxProducts() {
    const pidValue = getPidValue();
    let boxedProducts = [];

    if ($boxBar.length) {
        // get the modal quantity value
        modalQuantity = getModalQuantity();

        if (!modalQuantity) {
            closePersonalizationModal();
            return;
        }

        // Add the main product as the first boxed entry
        boxedProducts.push({
            pid: pidValue.toString(),
            qty: modalQuantity.toString(),
            options: []
        });

        // Loop through boxed products
        $boxBar.find(".box-bar-tile").each(function () {
            const productId = $(this).data("product-id");

            // Find existing product entry
            const existingProduct = boxedProducts.find(item => item.pid.toString() === productId.toString());

            if (existingProduct) {
                // Product exists → increase quantity
                // Multiply modal quantity into its count
                existingProduct.qty = (
                    parseInt(existingProduct.qty, 10) + parseInt(modalQuantity, 10)
                ).toString();
            } else {
                // Product does not exist → push new entry
                boxedProducts.push({
                    pid: productId.toString(),
                    qty: modalQuantity.toString(),
                    options: "[]"
                });
            }
        });
    }

    return boxedProducts.length ? boxedProducts : [];
}

/**
 * @description adds personalization
 * @param {Object} e - event object
 */
function addPersonalization(e) {
    e.preventDefault();
    $boxBar = $(".custom-box-bar");
    personalizationToUpperCase();

    const $form = $("#personalization-form");
    const hasErrors = checkErrors($form);
    if (hasErrors) {
        validateFormFields($form);
        return;
    }

    clearFormErrors($form);

    $("body").trigger("product:beforeAddToCart", this);
    var $currentBtn = $(this);
    var $minicart = $(".minicart");
    var pid = getPidValue();
    var $addToCartBtn = $(".add-to-cart").filter("[data-pid=" + pid + "]");

    var addToCartUrl = getAddToCartUrl();
    var csrfToken = $("input[id='add-to-cart-personalization-csrf-token'").val();
    var form = {
        pid: pid,
        childProducts: getChildProducts(),
        quantity: getQuantitySelected($currentBtn),
        csrf_token: csrfToken,
    };

    var optionsObj = JSON.stringify([{
        optionId: $currentBtn.data("option-id"),
        selectedValueId: $currentBtn.data("value-id"),
        actionName: $currentBtn.data("personalization-cbt-action-name"),
        payload: getPayload({ isVCType: $currentBtn.data("is-vc-type") }),
    }]);

    modalQuantity = getModalQuantity();

    if ($boxBar.length && modalQuantity) {
        // get the boxed products
        var pidsObj = boxProducts();

        // set the personalization options for the main product
        pidsObj[0].options = optionsObj;

        // add boxed products to form
        form.pidsObj = JSON.stringify(pidsObj);
    }

    if ($boxBar.length && modalQuantity == 0) {
        e.stopPropagation();
        setTriggerErrorMessage($(".custom-box-bar").data("box-max-qty-error"));
        disableButtons();
        closePersonalizationModal();
        return;
    }

    form.options = optionsObj;

    $($currentBtn).trigger("updateAddToCartFormData", form);
    if (addToCartUrl) {
        $.spinner().start();
        $.ajax({
            url: addToCartUrl,
            method: "POST",
            data: form,
            success: function (data) {
                //Handles the UI and logic for custom box interactions based on the presence of $boxBar and error state in data.
                if ($boxBar.length) {
                    if (data.isReplacement === true) {
                        $(".custom-box-bar-trigger").trigger("click");
                        windowReload();
                    } else {
                        // check if max quota is reached on any products
                        if (data.error || !data.finalResults.length) {
                            productQuantityError(data);
                            disableButtons();
                            closePersonalizationModal();
                            $.spinner().stop();
                            return;
                        } else {
                            $(".custom-box-bar-trigger").trigger("click");
                            calculatePersonalizationPrice();
                            windowReload();
                        }
                    }
                }

                $("body").trigger("product:afterAddToCart", data);
                $minicart.trigger("count:update", data);
                data.cartModel && updateCartTotals(data.cartModel);
                handleQuotaUpdate($addToCartBtn, data);
                $("#personalizationModal").modal("hide");

                if (!$boxBar.length) {
                    $.spinner().stop();
                    openCartModal();
                }
            },
            error: errorHandler
        });
    }
}

/**
 * @description updates personalization
 * @param {Object} e - event object
 */
function updatePersonalization(e) {
    e.preventDefault();
    personalizationToUpperCase();

    const $form = $("#personalization-form");
    const hasErrors = checkErrors($form);
    if (hasErrors) {
        validateFormFields($form);
        return;
    }

    clearFormErrors($form);

    $("body").trigger("product:beforeAddToCart", this);
    var $currentBtn = $(this);
    var actionURL = $currentBtn.data("action-url");
    const $personalizationModal = $("#personalizationModal");

    if (!actionURL) {
        return;
    }
    var payload = getPayload({ isVCType: $currentBtn.data("is-vc-type") });
    if (payload?.message === $currentBtn.data("field-initial-value")) { // no update, do nothing
        $personalizationModal.modal("hide");
        return;
    }

    var form = {
        pliUUID: $currentBtn.data("pli-uuid"),
        optionId: $currentBtn.data("option-id"),
        selectedValueId: $currentBtn.data("value-id"),
        actionName: $currentBtn.data("personalization-cbt-action-name"),
        ...payload,
        csrf_token: $("[name=csrf_token]").val()
    };

    $($currentBtn).trigger("updateAddToCartFormData", form);

    $.ajax({
        url: actionURL,
        method: "POST",
        data: form,
        success: function (data) {
            if (!data.success) {
                $personalizationModal.modal("hide");
                return;
            }
            $("body").trigger("product:afterAddToCart", data);
            $personalizationModal.modal("hide");

            $(`[data-personalization-add-${data.pliUUID}]`).addClass("d-none");
            var $edit = $(`[data-personalization-edit-${data.pliUUID}]`);
            $edit.find(".personalization-message").html(data.message.replace(/\n/g, "<br/>"));
            $edit.find(".personalization-price").text(data.price);
            data.cartModel && updateCartTotals(data.cartModel);
            $edit.removeClass("d-none");
            cartCustomBoxes.init();
            $.spinner().stop();
        },
        error: errorHandler
    });
}

/**
 * @description removes personalization
 * @param {Object} e - event Object
 */
function removePersonalization(e) {
    e.preventDefault();
    var $currentBtn = $(this);
    var actionURL = $currentBtn.data("action-url");

    if (!actionURL) {
        return;
    }

    var form = {
        pliUUID: $currentBtn.data("pli-uuid"),
        optionId: $currentBtn.data("option-id"),
        csrf_token:  $("[name=csrf_token]").val(),
        actionName: $currentBtn.data("personalization-cbt-action-name")
    };
    $.ajax({
        url: actionURL,
        method: "POST",
        data: form,
        success: function (data) {
            if (!data.success) {
                $("#personalizationModal").modal("hide");
                return;
            }
            $(`[data-personalization-edit-${data.pliUUID}]`).addClass("d-none");
            $(`[data-personalization-add-${data.pliUUID}]`).removeClass("d-none");
            data.cartModel && updateCartTotals(data.cartModel);
            $("#personalizationModal").modal("hide");
            cartCustomBoxes.init();
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        },
    });
}

/**
 * @param {Object} params
 * @return {Promise<Object>}
 */
function getModalInfo(params) {
    return new Promise((resolve, reject) => {
        $.ajax({
            url: params.actionURL,
            type: "get",
            dataType: "json",
            success: function (response) {
                if (!response.success) {
                    reject();
                }

                resolve(response);
            },
            error: function (e) {
                reject(e);
            }
        });
    });
}

/**
 * @param {Object} response
 */
function showPersonalizationModal(response) {
    $(".c-personalization-modal").remove();
    $body.append(response.data);
    updateRemainingChars();
    updateQuantity();

    const $textArea = $("#personalization-form-message");
    const msgConfiguration = $("#personalization-form-message").data("msg-configuration");
    if ($textArea.length) {
        const fallbackValue = 1;
        msgConfiguration.charactersPerLine = msgConfiguration.charactersPerLine > 0 ? msgConfiguration.charactersPerLine : fallbackValue;
        msgConfiguration.maxLines = msgConfiguration.maxLines > 0 ? msgConfiguration.maxLines : fallbackValue;
    }

    if (msgConfiguration && msgConfiguration.charactersPerLine && msgConfiguration.maxLines) {
        const { charactersPerLine, maxLines } = $textArea.data("msg-configuration");
        const maxCharacterCount = charactersPerLine * maxLines;
        const currentCharacterCount =  $textArea.val().replaceAll("\n", "").length;
        const $personalizationCounter = $(".personalization-counter");
        $textArea.removeAttr("maxLength");
        $(".counter-chars").text(maxCharacterCount - currentCharacterCount);
        $(document).off("input.withtextareaconfig");
        $(document).on("input.withtextareaconfig", "#personalization-form-message", { charactersPerLine, maxLines }, formatTextAsRequired);

        $textArea.on("keyup", function () {
            // When 10 or less characters remain available, set the aria-live attribute to polite to announce the remaining characters to screen reader users
            if (maxCharacterCount - $textArea.val().replaceAll("\n", "").length <= 10) {
                $personalizationCounter.attr("aria-live", "polite");
            } else {
                $personalizationCounter.attr("aria-live", "off");
            }
        });
    }

    $(".c-personalization-modal").find(".quantity-select")
        .select2({
            minimumResultsForSearch: -1
        });
    $(".avalability-messages-wrapper").append($(".avalability-messages").clone());
    $(".c-personalization-modal").modal("show");
    if ($(".product-detail").length && window.isApplePayExpressEnabled && window.isExpressPaymentsEnabled) {
        $("body").trigger("personalization:opened");
    }
    $.spinner().stop();
}

/**
 * @param {Object} response
 */
function showGiftWrappingModal(response) {
    $(".c-giftwrapping-modal").remove();
    $body.append(response.data);
    $(".c-giftwrapping-modal").find(".giftwrapper-select")
        .select2({
            minimumResultsForSearch: -1
        });

    $(".c-giftwrapping-modal").modal("show");
}

/**
 * @description showing giftwrapper modal
 */
function showGiftWrappingModalHandler() {
    const $currentButtonAction = $(this).data("action-url");

    if ($currentButtonAction) {
        getModalInfo({
            actionURL: $currentButtonAction
        })
            .then(showGiftWrappingModal)
            .catch(function (err) {
                console.log(err);
            });
    }
}

/**
 * @description showing personalization modal
 */
function showPersonalizationModalHandler(e, url) {
    const $currentButtonAction = $(this).data("action-url");

    if (url || $currentButtonAction) {
        getModalInfo({
            actionURL: url ? url : $currentButtonAction
        })
            .then(showPersonalizationModal)
            .catch(function (err) {
                console.log(err);
            });
    }
}

/**
 * @description update remaining chars in form input fields
 */
function updateRemainingChars() {
    var $inputs = $(".word-count");
    $inputs.each(function () {
        var $this = $(this);
        var maxLength = $this.attr("maxlength");
        var $counterChars = $this.closest(".form-group").find(".counter-chars");
        if ($this.val().trim().length > 0) {
            $counterChars.text(maxLength - $this.val().length);
        }
    });
}

/**
 * @description showing chars left in input field
 */
function charsCounter() {
    var $this = $(this);
    var $counterChars = $this.closest(".form-group").find(".counter-chars");
    var maxLength = $this.closest(".form-group").find(".form-control").attr("maxlength");
    $counterChars.text(maxLength - $this.val().length);
}

/**
 * @description update personalization quantity
 */
function updateQuantity() {
    var $productContainer = $(".product-detail");
    if ($productContainer.length) {
        var quantityOptions = $productContainer.find(".quantity-select").html();
        $("#personalizationModal").find(".quantity-select").empty().html(quantityOptions);
    }
}

$body.on("click", "personalization-close", function() {
    $(".c-personalization-modal").modal("hide");
});
$body.on("click", "[data-add-personalization]", addPersonalization);
$body.on("click", "[data-remove-personalization]", removePersonalization);
$body.on("click", "[data-update-personalization]", updatePersonalization);
$body.on("click", "[data-target-personalization-modal]", showPersonalizationModalHandler);

$body.on("click", "giftwrapping-close", function() {
    $(".c-giftwrapping-modal").modal("hide");
});
$body.on("click", "[data-update-giftwrapping]", updateGiftwrapping);
$body.on("click", "[data-remove-giftwrapping]", removeGiftwrapping);
$body.on("click", "[data-target-giftwrapping-modal]", showGiftWrappingModalHandler);
$body.on("input", ".word-count", charsCounter);

$body.on("hide.bs.modal", ".c-personalization-modal", closePersonalization);
$body.on("hidden.bs.modal", ".c-personalization-modal", hiddenPersonalizationHandler);
